import React from "react";
import "./../styles/rx-label.css";
import LogoLabel from "./../graphics/LogoLabel.png";
import { Col, Row, Typography } from "antd";
import { formatDateInMMDDYYYY } from "../helpers/date";
export default function RxLabel({ order }: IRxLabelDetails) {
  const { shippingDetails, processingDetails, createdAt } = order;
  const { firstName, lastName, phoneNumber, address } = shippingDetails;
  const formula = processingDetails.formulaAssigned?.activeIngredients || "";
  const getPrescribedDate = () => {
    if (processingDetails.assignedDate) {
      return formatDateInMMDDYYYY(processingDetails.assignedDate);
    }
    return formatDateInMMDDYYYY(new Date());
  };
  const usedByDate = () => {
    const currentDate = processingDetails.assignedDate
      ? new Date(processingDetails.assignedDate)
      : new Date();
    const usedBy = new Date(currentDate.setDate(currentDate.getDate() + 60));
    return formatDateInMMDDYYYY(usedBy);
  };
  return (
    <Row className="rx-label-container">
      <Col span={18}>
        <div className="top-container">
          <div>
            <img src={LogoLabel} style={{ width: "23px" }} />
          </div>
          <div className="top-container-left">
            <Typography className="rx-label-title">
              Rx #{processingDetails.orderNumber} crafted on{" "}
              {formatDateInMMDDYYYY(createdAt)}
              &nbsp; for
            </Typography>
            <Typography className="rx-label-user-details">
              {firstName} {lastName}
            </Typography>
            <Typography className="rx-label-user-details">
              {phoneNumber}
            </Typography>
            <Typography className="rx-label-user-details">
              {address.street1} {address.city}, {address.state}{" "}
              {address.zipCode}
            </Typography>
          </div>
        </div>
        <div className="rx-label-formula-details">
          <Typography className="rx-label-title">Cream Ingredients:</Typography>
          {formula.split(",").map((item) => {
            return (
              <Typography key={item} className="formula-rx-label-user-details">
                {item}
              </Typography>
            );
          })}
          {/* <Typography className="formula-rx-label-user-details">
            Diclofenac 3%
          </Typography>
          <Typography className="formula-rx-label-user-details">
            Camphor 2%
          </Typography>
          <Typography className="formula-rx-label-user-details">
            Menthol 3%
          </Typography>
          <Typography className="formula-rx-label-user-details">
            Amitriptyline 2%
          </Typography>
          <Typography className="formula-rx-label-user-details">
            Transdermal pain base
          </Typography>
          <Typography className="formula-rx-label-user-details">
            Transdermal pain base <strong>120 clicks</strong>
          </Typography> */}
        </div>
        <div className="rx-label-directions">
          <Typography className="directions-rx-label-user-details f-11">
            <strong>Directions:</strong>
            {processingDetails.otherInstructions
              ? processingDetails.otherInstructions
              : processingDetails.instructions}
            {/* Apply 1 click to the right knee
            everyday in the morning */}
          </Typography>
          <Typography className="directions-rx-label-user-details">
            Prescribed by <strong>Dr. Faryal Shareef</strong> on{" "}
            <strong>{getPrescribedDate()}</strong>
          </Typography>
          <Typography className="directions-rx-label-user-details">
            Use by <strong> {usedByDate()}</strong>. You have <strong>2</strong>{" "}
            refills left.
          </Typography>
        </div>
        <div className="rx-made-by">
          <Typography className="rx-made-by-label">
            Cream made at Friendly pharmacy located at 1654 st. nicholas ave,
            New York, NY 10040 (212) 568-4000
          </Typography>
        </div>
      </Col>
      <Col span={6}>
        <Typography className="rx-label-caution">
          Caution: Federal law prohibits the transfer of this drug to any person
          other than the patient for whom it was prescribed. For external use
          only. Avoid contact with eyes. Wash hands after use. Stop using if
          experiencing allergic reaction.
        </Typography>
      </Col>
    </Row>
  );
}
